import { render } from "./ClientVentasProformar.vue?vue&type=template&id=205abf14&scoped=true"
import script from "./ClientVentasProformar.vue?vue&type=script&lang=js"
export * from "./ClientVentasProformar.vue?vue&type=script&lang=js"

import "./ClientVentasProformar.vue?vue&type=style&index=0&id=205abf14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-205abf14"]])

export default __exports__